import React from "react";
import { FaDesktop, FaMobileAlt, FaAndroid, FaHistory } from "react-icons/fa";


const PreviousOrders = () => {

    return (
         <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">

            {/* Panel Header */}
            <div className="flex items-center gap-4 mb-8">
                <FaHistory className="text-pink-600 text-5xl" />
                <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900">Previous Orders </h1>
            </div>

            {/* Tags Section */}
            <div className="flex flex-wrap items-center gap-3 mb-10">
                <span className="bg-pink-100 text-pink-700 px-4 py-1 rounded-full text-sm font-semibold">Seller</span>
                <span className="bg-yellow-100 text-yellow-700 px-4 py-1 rounded-full text-sm font-semibold">Buyer</span>
                <div className="ml-auto flex gap-2 flex-wrap">
                    <span className="bg-blue-50 text-blue-700 px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1 hover:bg-blue-100 transition">
                        <FaDesktop /> Web
                    </span>
             
                    <span className="bg-green-50 text-green-700 px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1 hover:bg-green-100 transition">
                        <FaAndroid /> Android
                    </span>
                </div>
            </div>

            {/* Intro Text */}
            <div className="bg-gray-50 p-6 rounded-2xl ">
                <p className="text-gray-700 text-start text-base leading-relaxed ">
                    Selzor’s user-friendly ordering system allows both 'Buyers' and 'Suppliers' to quickly access past orders from a chosen supplier or buyer. On the web app, up to 25 recent orders can be viewed directly within the order cart, while on the mobile app, the last 25 orders are just a tap away.
                </p>
         
            </div>

            <p className="mt-6 p-6  text-gray-500 text-base text-start ">
                You can not only browse these past orders but also add any items from them directly into the currently selected order cart.
            </p>


        </div>
    );
};

export default PreviousOrders;